import { configureStore } from '@reduxjs/toolkit';

import authReducer              from './store/slices/auth';
import employeeReducer          from './store/slices/employeeSlice';
import dropdownReducer          from './store/slices/dropdownSlice';
import imageReducer             from './store/slices/imageSlice';
import attendanceReducer        from './store/slices/attendanceSlice';
import attendanceadjustmentReducer  from './store/slices/attendanceadjustmentSlice';
import leaveReducer from './store/slices/leaveSlice';
import leaveAdjustmentReducer from './store/slices/leaveAdjustmentSlice';
import attendanceApprovalReducer from './store/slices/attendanceApprovalSlice';
import leaveTypesReducer from './store/slices/leaveTypesSlice';
import leavePolicyReducer from './store/slices/leavePolicySlice';
import attendanceSummaryReducer from './store/slices/attendanceSummarySlice';
import overtimeReducer          from './store/slices/overtimeSlice';
import filterAttendanceReducer  from './store/slices/filterAttendanceSlice';
import physicalLocationReducer  from './store/slices/physicalLocationSlice';
import locationMasterReducer    from './store/slices/locationMasterSlice';
import uiReducer                from './store/slices/uiSlice';
import dashboardReducer         from './store/slices/dashboardSlice';
import assetReducer             from './store/slices/assetSlice';
import hrReducer                from './store/slices/hrSlice';
import empReducer               from './store/slices/newEmpSlice';
import financeReducer           from './store/slices/financeSlice';
import procurementReducer       from './store/slices/procurementSlice';
import productionReducer        from './store/slices/productionSlice';
import commercialReducer        from './store/slices/commercialSlice';
import subcontractReducer       from './store/slices/subcontractSlice';
import privilegeReducer         from './store/slices/privilegeSlice';
import holidayReducer           from './store/slices/holidaySlice';

import newDesignationReducer       from './store/slices/designationSlice';
import newDepartmentReducer        from './store/slices/departmentSlice';
import newLocationReducer          from './store/slices/locationSlice';
import newEmployeeCategoryReducer  from './store/slices/employeeCategorySlice';
import newGradeReducer             from './store/slices/gradeSlice';
import newBankReducer       from './store/slices/bankSlice';
import newBankBranchReducer       from './store/slices/bankBranchSlice';
import newShiftReducer       from './store/slices/shiftSlice';

import payrollReducer           from './store/slices/payrollSlice';
import cFormReducer from "./store/slices/cFormSlice";
import kFormReducer from "./store/slices/kFormSlice";
import monthlyAllocationReducer from "./store/slices/monthlyAllocationSlice";

const store = configureStore({
  reducer: {
    auth:             authReducer,
    employees:        employeeReducer,
    dropdowns:        dropdownReducer,
    images:           imageReducer,
    attendance:       attendanceReducer,
    adjustment:       attendanceadjustmentReducer,
    attendanceApproval: attendanceApprovalReducer,
    attendanceSummary: attendanceSummaryReducer,
    filterAttendance:  filterAttendanceReducer,
    leave: leaveReducer,
    leaveAdjustment: leaveAdjustmentReducer,
    leaveTypes: leaveTypesReducer,
    leavePolicy: leavePolicyReducer,
    overtime:          overtimeReducer,
    physicalLocation: physicalLocationReducer,
    locationMaster:   locationMasterReducer,
    ui:               uiReducer,
    dashboard:        dashboardReducer,
    asset:            assetReducer,
    hr:               hrReducer,
    emp:              empReducer,
    finance:          financeReducer,
    procurement:      procurementReducer,
    production:       productionReducer,
    commercial:       commercialReducer,
    subcontract:      subcontractReducer,
    holiday:          holidayReducer,
    payroll:          payrollReducer,
    privilege:        privilegeReducer,
    cForm: cFormReducer,
    kForm: kFormReducer,
    monthlyAllocation: monthlyAllocationReducer,

    designationSlice: newDesignationReducer,
    bankSlice: newBankReducer,
    bankBranchSlice: newBankBranchReducer,
    shiftSlice: newShiftReducer,
    departmentSlice: newDepartmentReducer,
    locationSlice: newLocationReducer,
    employeeCategorySlice: newEmployeeCategoryReducer,
    gradeSlice: newGradeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;
